import { ApiFehler, type Artikelstamm } from './api';
import { konfigAusStamm, type KassenProfil, type SchnellwahlKonfig } from './schnellwahl';

/**
 * Verkaufsansicht aus Artikelstamm und dem wirksamen Schnellwahl-Profil der Kasse (P10). Wer den
 * Verkaufs-Zwischenspeicher schreibt (z. B. die Einrichtung), darf das Profil nicht weglassen –
 * sonst fehlen Reihenfolge, Farben und Ausblendungen bis zur nächsten Stammänderung.
 * null = Profil nicht ermittelbar (Netz/Server): dann nichts schreiben, der Sync-Dienst leitet
 * die Ansicht selbst ab. 404/501 = Server ohne Profile → Ansicht ohne Profil wie bisher.
 */
export async function verkaufsKonfig(
  quelle: { schnellwahlProfil(kassenId: string): Promise<KassenProfil | null> },
  kassenId: string,
  stamm: Artikelstamm,
): Promise<SchnellwahlKonfig | null> {
  let profil: KassenProfil | null;
  try {
    profil = await quelle.schnellwahlProfil(kassenId);
  } catch (e: unknown) {
    if (e instanceof ApiFehler && (e.status === 404 || e.status === 501)) {
      profil = null;
    } else {
      return null;
    }
  }
  return konfigAusStamm(stamm, profil);
}
